var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"col-12 p-0",attrs:{"options":_vm.question.settings.options,"multiple":"","dir":"rtl"},scopedSlots:_vm._u([{key:"no-options",fn:function(){return [_vm._v(" Select from the list ")]},proxy:true}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }